import styled from "styled-components";

interface StyleProps {}

export const DivCartFailModal = styled.span<StyleProps>`
  & {
    .akn-cart-fail-modal-wrapper {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 10000;
    }

    .akn-cart-fail-modal {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 300px;
      height: 200px;
      background-color: white;
      border-radius: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &__icon {
        font-size: 40px;
        color: black;
        pointer-events: none;
        user-select: none;
      }

      &__text {
        font-size: 1.25rem;
        pointer-events: none;
        user-select: none;
        text-align: center;
      }
      &__close {
        position: absolute;
        top: 0;
        right: 10px;
        font-size: 1.25rem;
        color: black;
        cursor: pointer;
        padding: 10px;
      }
    }
  }
`;
